module.exports = __webpack_public_path__ + "static/newsletterIllustration-fbcd850dbe56a3d2503add89eb599348.svg";